import { useEffect, useRef, useState } from "react";
import { Loader2, Tractor } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

/** Informe de área agrícola: primero calcula por satélite lo que falte (de a pocos), después descarga el PDF. */
export function InformeAreaAgricola({ params, testid = "titulares-area-pdf" }) {
  const [estado, setEstado] = useState(null);
  const vivo = useRef(true);
  useEffect(() => { vivo.current = true; return () => { vivo.current = false; }; }, []);
  const bajar = async () => {
    const r = await api.get("/portal/titulares/area-agricola.pdf", { params, responseType: "blob", timeout: 240000 });
    const nombre = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "TierraScore_area_agricola.pdf";
    const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    const a = document.createElement("a"); a.href = url; a.download = nombre; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  };
  const correr = async () => {
    try {
      for (;;) {
        const s = (await api.post("/portal/titulares/area-agricola/preparar", params, { timeout: 120000 })).data;
        if (!vivo.current) return;
        setEstado(s);
        if (!s.pendientes) break;
        await new Promise((ok) => { setTimeout(ok, 10000); });
      }
      setEstado((s) => ({ ...s, pdf: true }));
      await bajar();
      toast.success("Informe de área agrícola generado");
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "No se pudo generar el informe, reintentá"); }
    finally { if (vivo.current) setEstado(null); }
  };
  const txt = !estado ? null : estado.pdf ? "Armando PDF…" : estado.pendientes ? `Calculando área mecanizada por satélite: ${estado.listos} de ${estado.total} listos (2–4 min c/u)…` : "Armando PDF…";
  return <button onClick={correr} disabled={!!estado} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1f7a4d] text-white px-4 py-1 text-xs font-semibold hover:bg-[#124a2f] disabled:opacity-70" data-testid={testid}>
    {estado ? <><Loader2 className="w-4 h-4 animate-spin" /><span data-testid={`${testid}-progreso`}>{txt}</span></> : <><Tractor className="w-4 h-4" />Informe de área agrícola (PDF)</>}
  </button>;
}
